// 1) Mega nav tab behaviour
document.addEventListener('mouseover', (event) => {
  const trigger = event.target.closest('[data-meganav-tab-trigger]');
  if (!trigger) return;

  const container = trigger.closest('.meganav-custom--layout_1');
  if (!container) return;

  const tab = trigger.getAttribute('data-meganav-tab');
  if (!tab) return;

  // Toggle active state on triggers
  container
    .querySelectorAll('[data-meganav-tab-trigger]')
    .forEach((btn) => {
      btn.classList.toggle('is-active', btn === trigger);
    });

  // Toggle active state on panels
  container
    .querySelectorAll('[data-meganav-tab-panel]')
    .forEach((panel) => {
      const panelTab = panel.getAttribute('data-meganav-tab');
      panel.classList.toggle('is-active', panelTab === tab);
    });
});


// 2) Helper: reset quantity in the current product form
const resetQuantityForProductForm = (root) => {
  if (!root) return;

  const qtyInput = root.querySelector('[data-quantity-input]');
  if (!qtyInput) return;

  qtyInput.value = 1;
};

// 3) Reset quantity when a select-based option changes
document.addEventListener('change', (event) => {
  const optionInput = event.target.closest('select[name^="options["]');
  if (!optionInput) return;

  const productForm = optionInput.closest('form');
  if (!productForm) return;

  resetQuantityForProductForm(productForm);
});

// 4) Reset quantity when an option button / card is clicked
document.addEventListener('click', (event) => {
  // Covers swatches, chips, AND our new card-style buttons
  const optionButton = event.target.closest('[data-option-buttons] [data-button], [data-variant-card]');
  if (!optionButton) return;

  const productForm = optionButton.closest('form');
  if (!productForm) return;

  resetQuantityForProductForm(productForm);
});

// 5) (Optional) If the theme fires a variant-change event, hook it
document.addEventListener('product:variant-change', (event) => {
  const target = event.target;
  const productForm =
    (target && target.closest && target.closest('form')) ||
    document.querySelector('form[data-product-form]');

  if (!productForm) return;

  resetQuantityForProductForm(productForm);
});
